module.exports = __webpack_public_path__ + "img/permission.0fe9907d.png";